import { Component, Injector, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { Borrower, ApplicationContext, LoanApplication, LoanStatus } from 'src/app/models';
import { KeyDateType } from 'src/app/models/key-dates/key-date-types.enum';
import { MortgageCalculationDetails } from 'src/app/models/mortgage-calculation-details.model';
import { UrlaMortgage } from 'src/app/modules/urla/models/urla-mortgage.model';
import { LoanService } from 'src/app/services/loan';
import { ApplicationContextBoundComponent } from 'src/app/shared/components/application-context-bound.component';

@Component({
    selector: 'tpo-loan-summary-reverse',
    templateUrl: 'tpo-loan-summary-reverse.component.html',
    styleUrls: ['./tpo-loan-summary-reverse.component.scss'],
    standalone: false
})
export class TpoLoanSummaryReverseComponent extends ApplicationContextBoundComponent implements OnInit {

  application: LoanApplication;
  mortgage: UrlaMortgage;
  mortgageCalculationDetails: MortgageCalculationDetails;
  borrowers: Borrower[];

  loanStatus: LoanStatus;

  @Input()
  isTpoSubmitted: boolean = false;

  protected isPRMG: boolean = false;

  private _applicationContextSubscription: Subscription;

  private _mortgageCalculationDetailsSubscription: Subscription;

  constructor(private readonly injector: Injector,
    private readonly _loanService: LoanService) {
    super(injector);
  }

  ngOnInit() {
    this.loadLoanRelatedData(this.applicationContext);

    this._applicationContextSubscription =
      this.applicationContextService.loanInfoChanges.subscribe(({ context }) => {
        this.loadLoanRelatedData(context);
      });

    this._mortgageCalculationDetailsSubscription = this.applicationContextService.mortgageCalculationDetailsChangedEvent.subscribe((context) => {
      this.mortgageCalculationDetails = context.currentMortgageCalculationDetails;
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    if (this._applicationContextSubscription) {
      this._applicationContextSubscription.unsubscribe();
    }
    this._mortgageCalculationDetailsSubscription?.unsubscribe();
  }

  private loadLoanRelatedData = (context: ApplicationContext) => {
    this.isPRMG = context.isCompanyPRMG;

    if (context.application) {
      this.application = context.application;
      this.mortgage = context.currentMortgage;
      this.mortgageCalculationDetails = context.currentMortgageCalculationDetails;
      const loanStatus = context.globalConfig.loanStatus.find(s => s.loanStatusId == this.application.loanStatusId);
      this.loanStatus = loanStatus;

      this.isTpoSubmitted = context.applicationKeyDatesByType
        ? !!context.applicationKeyDatesByType[KeyDateType.TpoSubmission] : false;
    }
    if (context.borrowers) {
      this.borrowers = context.borrowers;
    }
  };
}
